import React, { Component } from 'react'
import styled from 'styled-components'
import ArrowIcon from 'components/Svg/arrow.svg'
import { Button } from 'components/Counter'
import LessSvg from 'components/Counter/images/less.component.svg'
import PlusSvg from 'components/Counter/images/more.component.svg'
import Select from 'components/Select'
import findIndex from 'lodash/findIndex'
import { selectMapper } from 'utils'

export default class EquipmentsList extends Component {
  state = {
    opened: []
  }

  setOpened = (item) => {
    const { opened } = this.state
    const found = findIndex(opened, ({ id }) => id === item.id)

    if (found !== -1) {
      opened.splice(found, 1)
    } else {
      opened.push(item)
    }

    this.setState({ opened })
  }

  /**
   * Sets the quantity of the opened
   */
  setOpenedQuantity = (item) => {
    const clone = { ...item }
    const { opened } = this.state
    const found = findIndex(opened, ({ id }) => id === clone.id)

    if (found !== -1) {
      if (!clone.quantity) {
        opened.splice(found, 1)
      } else {
        opened[found] = { ...clone }
      }
    }

    this.setState({ opened })
    this.props.onChange && this.props.onChange(clone)
  }

  componentWillReceiveProps (nextProps) {
    // Reset opened if division changed
    if (nextProps.division && this.props.division) {
      if (nextProps.division.id !== this.props.division.id) {
        this.setState({ opened: [] })
      }
    }
  }

  renderListItem = (item, index) => {
    const { allEquipments, division, onChangeEquipmentType } = this.props
    const opened = this.state.opened.find(({ id }) => item.id === id)
    const key = opened && opened.svg_key

    let types
    let hasMultipleTypes

    if (opened && key) {
      /* eslint-disable camelcase */
      types = allEquipments
        .filter(({ house_divisions }) => house_divisions.indexOf(division.id) !== -1)
        .filter(({ svg_key, id }) => svg_key === key && id !== item.id)
        .map(selectMapper)
      /* eslint-enable camelcase */
      hasMultipleTypes = types && !!types.length
    }

    return (
      <ListItem
        key={`li-${index}`}
        opened={opened}
      >
        <ListItemHeader onClick={() => this.setOpened(item)} opened={opened}>
          <Name>{item.name}</Name>
        </ListItemHeader>

        {opened &&
          <SmallEdit>
            <EditItem>
              <Name>Quantidade</Name>
              <Selector>
                <CounterButton
                  less
                  disabled={opened.quantity === 0}
                  onClick={() => { this.setOpenedQuantity({ ...opened, quantity: opened.quantity - 1 }) }}
                >
                  <LessSvg />
                </CounterButton>
                <Quantity>{opened.quantity}</Quantity>
                <CounterButton
                  plus
                  margin
                  onClick={() => { this.setOpenedQuantity({ ...opened, quantity: opened.quantity + 1 }) }}
                >
                  <PlusSvg />
                </CounterButton>
              </Selector>
            </EditItem>
            {hasMultipleTypes &&
            <EditItem>
              <Name>Tipo</Name>
              <TypeSelect
                margin
                placeholder={`Tipo`}
                items={types}
                arrowIcon={ArrowIcon}
                onChange={(newType) => onChangeEquipmentType(item, newType)}
              />
            </EditItem>
            }
          </SmallEdit>
        }

      </ListItem>
    )
  }
  render () {
    const { equipments } = this.props
    return (
      <List>
        {equipments &&
        equipments.map(this.renderListItem)
      }
      </List>
    )
  }
}

const List = styled.div`
max-height: 600px;
height: calc(100% - 6px);
`

const ListItem = styled.div`
box-shadow: inset 0 -1px 0 0 #EFEFEF;
text-align: left;
cursor: pointer;
position: relative;
`

const Name = styled.span`
color: #3E3E3E;
font-size: 14px;
font-weight: bold;
line-height: 14px;
padding: 10px;
display: inline-block;
`

const SmallEdit = styled.div`
background-color: #F9F9F9;
box-shadow: inset 0 1px 0 0 #EFEFEF, inset 0 -1px 0 0 #EFEFEF;
padding: 0 10px;
`

const EditItem = styled.div`
box-shadow: inset 0 -1px 0 0 #EFEFEF;
text-align: left;
display: flex;
justify-content: space-between;
align-items: center;
`

const CounterButton = styled(Button)`
width: 28px;
display: inline-block;
vertical-align: middle;
float: none;
margin: 0;

svg {
  margin: 0;
  height: 7px;
  width: 9px;
}
`

const Selector = styled.div`
margin-right: 10px;
`

const Quantity = styled.div`
display: inline-block;
vertical-align: middle;
margin: 0 5px;
`

const ListItemHeader = styled.div`
&:after {
  content: "";
  display: block;
  background: url(${ArrowIcon});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 12px;
  height: 12px;
  position: absolute;
  top: 12px;
  right: 15px;
}
${({ opened }) => opened && `
  &:after {
    transform: rotate(180deg)
  }
`}
`

const TypeSelect = styled(Select)`
  z-index: 55;
  width: 100%;
  max-width: 160px;

  > div:first-child {
    padding: 5px;
  }

  > div:last-child {
    position: absolute;
    max-width: 200px;
  }
`



// WEBPACK FOOTER //
// ./src/containers/EquipmentsListSimple/index.js